import { IconButton, Text, Tooltip } from '@civilgrid/ui/components';

const url = 'https://civilgrid.help.usepylon.com/articles/4433444809-inviting-team-members-on-civilgrid';

/** Radix sees Escape before the input does; keeping the dialog open lets an open suggestion list close itself instead. */
export function keepOpenOnSuggestionListEscape(event: KeyboardEvent) {
  if (event.target instanceof HTMLElement && event.target.getAttribute('aria-expanded') === 'true') {
    event.preventDefault();
  }
}

export const AboutUserRoles = ({
  trigger = <IconButton icon="questionMarkCircled" variant="hollow" size="icon" aria-label="About user roles" />,
}: {
  trigger?: React.ReactNode;
}) => {
  return (
    <Tooltip
      asChild
      side="left"
      className="w-96 max-w-sm bg-white p-3"
      contentChildren={
        <div className="flex flex-col gap-2 text-left">
          <Text className="font-semibold">About User Roles</Text>
          <Text className="text-xs">
            Unsure what role to give? "Engineer/Staff" is a safe default if the new member is a colleague. If the new
            member is an external user(s), "View-Only" is the safe default.
          </Text>
          <Text className="text-xs">Roles can always be changed in this page after users have been added.</Text>
          <Text className="text-xs">
            Check out this{' '}
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-50 underline hover:text-blue-60"
            >
              support article
            </a>{' '}
            for more info on inviting team members.
          </Text>
        </div>
      }
    >
      {trigger}
    </Tooltip>
  );
};
